export default __webpack_public_path__ + "static/media/Wind's Grasp.67e3a2b3.jpg";